import Auth from "../components/Auth"
import FullPageLayout from "../layout/FullPageLayout"

export const AuthPage = () => {
    return (
      <FullPageLayout child={<Auth />}/>
    )
}